import YogaLabels from './YogaLabels'

export default YogaLabels
// eslint-disable-next-line import/export
export * from './YogaLabels'
